const killer = () => {


    if (window.top !== window.self) {

        setInterval(function () {

            const style1 = [
                'color: white',
                'text-shadow: 2px 2px black',
                'background: firebrick',
                'font-size: 4em',
                'border: 1px solid black',
                'border-radius: 10px',
                'padding: 20px',
                'font-family: fantasy'
            ].join(';');

            const flame = String.fromCodePoint(0x1F525);
            console.log(`%c${flame}Ripley frame busting${flame}`, style1);
            console.log(`%cThis website don't allow frames on another sites, you are being redirected!`, 'color: black; font-weight: bold;');
            window.top.location.replace(window.location);

        }, 1);

    }
}

export default {
    killer,
}